import { AuthContext } from 'context/AuthContext';
import { useContext, useEffect, useState } from 'react';

const useCheckPermission = roles => {
  const { user } = useContext(AuthContext);
  const [userAllow, setUserAllow] = useState(false);

  useEffect(() => {
    if (roles?.length > 0) {
      setUserAllow(
        roles.includes(user.user_role) || user.user_role === 'Admin'
      );
    } else {
      setUserAllow(user.user_role === 'Manager' || user.user_role === 'Admin');
    }
  }, [roles]);

  return { userAllow, role: user.user_role };
};

export default useCheckPermission;
